// *********************************
// CoolGames Builder JavaScript file
import { tgfSettings } from "../../game_logic/framework/tgfSettings";
// *********************************
export var tgfSettingsOverride = function () {
    "use strict";
    tgfSettings.nakama = {
        // AngryBirds DEV
        key: "KLT3NwSsXCGtzd3GIhr",
        endpoint: "public.angry-birds.nakama.sandbox.cg-gb.com",
        isProdVersion: false,
        // AngryBirds DEV
        fbAppId: "1292078317579836",
        // AngryBirds DEV
        fbAppToken: "EAASXI20kLjwBAO4KfJjPwwxQQSJCthVoe8vGrzdZCfkbNCYkR1gm4yaMivL74bLI3VNyivGa6NAcvysYVAHUdXcPFZBwGVvWmgSQyoI91OppZA6isob7Oo7IK8JNuRMHRsNxOVdekXZA2gl6Qi4yqzJQR8ZCnOk8i2sAbJbm9FgZDZD"
    };
    tgfSettings.environment = "DEV";
    tgfSettings.enableDebugSettings = true;
    tgfSettings.facebook = {
        // AngryBirds DEV
        rewardedVideoPlacementId: "1825153594465039_1838291466484585",
        interstitialPlacementId: "1825153594465039_1935367346776996"
    };
    tgfSettings.analytics = {
        beaconGameKey: "abinstantstage_4a42b1a6",
        beaconSecretKey: "X1N8mfc0BjdRMSDcT4D9PCMAnXYtyp67",
        beaconDebugMessages: true
    };
    tgfSettings.matchTurnExpirationTime = (72 * 60 * 60); // in seconds
};
